import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(fab, fas, far);

const CFPreviewCard = (props) => {
  const style = props.style || "default";

  const defaultStyle = () => {
    return (
      <div
        className={`cf-preview-card default-style min-w-[50px] flex-grow flex flex-col ${props.className ? props.className : ""}`}
        data-object-id={props?.objectId}
      >
        <div
          className="relative rounded-xl cursor-pointer flex-1"
          onClick={props.onClick}
        >
          <div
            className="w-full rounded-xl border-solid border-1 border-slate-300 h-full min-h-[100px]"
            style={{
              backgroundImage: `url(${props.imageUrl ? props.imageUrl : ""})`,
              backgroundPosition: "top center",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
            }}
          />

          <div className="thumbnail-overlay absolute inset-0 bg-transparent hover:bg-white dark:hover:bg-slate-800 hover:bg-opacity-50 dark:hover:bg-opacity-50 cursor-pointer rounded-lg">
            <button
              style={{ display: "none" }}
              className="thumbnail-button absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 border-solid border-[1px] border-slate-200 py-2 px-4 rounded-lg text-base cursor-pointer bg-white whitespace-nowrap py-[0.6rem] px-[0.9rem]"
            >
              <div className="flex items-center justify-center gap-1">
                <svg
                  width="15"
                  height="14"
                  viewBox="0 0 15 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.43047 1.3999C7.43047 1.04092 7.13945 0.749902 6.78047 0.749902C6.42148 0.749902 6.13047 1.04092 6.13047 1.3999H7.43047ZM6.13047 12.5999C6.13047 12.9589 6.42148 13.2499 6.78047 13.2499C7.13945 13.2499 7.43047 12.9589 7.43047 12.5999H6.13047ZM4.33047 1.3999V2.0499H11.3305V1.3999V0.749902H4.33047V1.3999ZM13.4305 3.4999H12.7805V10.4999H13.4305H14.0805V3.4999H13.4305ZM11.3305 12.5999V11.9499H4.33047V12.5999V13.2499H11.3305V12.5999ZM2.23047 10.4999H2.88047V3.4999H2.23047H1.58047V10.4999H2.23047ZM4.33047 12.5999V11.9499C3.52966 11.9499 2.88047 11.3007 2.88047 10.4999H2.23047H1.58047C1.58047 12.0187 2.81169 13.2499 4.33047 13.2499V12.5999ZM13.4305 10.4999H12.7805C12.7805 11.3007 12.1313 11.9499 11.3305 11.9499V12.5999V13.2499C12.8493 13.2499 14.0805 12.0187 14.0805 10.4999H13.4305ZM11.3305 1.3999V2.0499C12.1313 2.0499 12.7805 2.69909 12.7805 3.4999H13.4305H14.0805C14.0805 1.98112 12.8493 0.749902 11.3305 0.749902V1.3999ZM4.33047 1.3999V0.749902C2.81169 0.749902 1.58047 1.98112 1.58047 3.4999H2.23047H2.88047C2.88047 2.69909 3.52966 2.0499 4.33047 2.0499V1.3999ZM6.78047 1.3999H6.13047V12.5999H6.78047H7.43047V1.3999H6.78047ZM6.78047 6.9999V7.6499H13.0805V6.9999V6.3499H6.78047V6.9999Z"
                    fill="black"
                  />
                </svg>
                {props.buttonLabel || "Select"}
              </div>
            </button>
          </div>
        </div>

        <div className="flex justify-between mt-4 flex-shrink-0">
          <h4
            className="text-xl font-medium cursor-pointer whitespace-nowrap text-ellipsis overflow-hidden max-w-[80%] m-0"
            onClick={props.onClick}
          >
            {props.title}
          </h4>

          {props.icon && (
            <div
              className="flex items-center cursor-pointer text-slate-500"
              onClick={props.onIconClick}
            >
              <FontAwesomeIcon icon={props.icon} />
            </div>
          )}
        </div>
      </div>
    );
  };

  const boxedStyle = () => {
    return (
      <div
        className={`cf-preview-card boxed-style min-w-[50px] flex-grow min-h-[100px] ${props.className ? props.className : ""}`}
        data-object-id={props?.objectId}
      >
        <div
          className="w-full relative h-full p-4 pb-[1rem] bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-black dark:text-slate-300 dark:hover:text-white rounded-lg cursor-pointer flex flex-col justify-between"
          onClick={props.onClick}
        >
          <div
            className="w-full flex-1 flex items-center justify-center"
          >
            <div
              className="w-full pt-6 h-[80%] bg-white dark:bg-slate-950 text-blue-600 dark:text-white rounded-lg text-center text-4xl whitespace-no-wrap"
              style={{
                backgroundImage: `url(${
                  props.imageUrl ? props.imageUrl : ""
                })`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "100% auto",
              }}
            ></div>
          </div>

          {props.title && (
            <div className="w-full mt-3 text-lg whitespace-nowrap text-ellipsis overflow-hidden text-center">
              {props.title}
            </div>
          )}

          <div className="thumbnail-overlay absolute leading-110px inset-0 bg-transparent hover:bg-white dark:hover:bg-slate-800 hover:bg-opacity-50 dark:hover:bg-opacity-50 cursor-pointer rounded-lg flex items-center justify-center">
            <button
              style={{ display: "none" }}
              className="thumbnail-button border-[1px] border-solid border-black dark:border-white py-1.5 sm:py-2 px-3 sm:px-5 rounded-lg text-sm sm:text-lg cursor-pointer font-semibold bg-black dark:bg-slate-800 dark:bg-opacity-80 text-white transition-all duration-200 hover:scale-105"
            >
              {props.buttonLabel || "Select"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      {style === "default" && defaultStyle()}
      {style === "boxed" && boxedStyle()}
    </React.Fragment>
  )
};

export default CFPreviewCard;
